import React, { useRef } from "react";
import styles from "./style.module.css";
import CompareSvg from "../../../../assets/SVG/CompareSvg";
import HeartSvg from "../../../../assets/SVG/HeartSvg";
import ShopCartSvg from "../../../../assets/SVG/ShopCartSvg";
import lang from "../../../../lang/lang";
import langData from "../../../../lang/data";
import { useDispatch, useSelector } from "react-redux";
import {
  addCardStore,
  addCompare,
  addCompares,
  addFavorites,
  addShopCartCount,
  addWishList,
  removeCompares,
  removeFavorites,
  setCompareProductAnimation,
  setHeartProductAnimation,
  setShopCartProductAnimation,
} from "../../../../store/MainSlice";
import UseCalcPrice from "../../../../helpers/UseCalcPrice";
import getImageUrl from "../../../../helpers/getImageUrl";
import defaultImg from "../../../../assets/defaultImg.png";
import { setOpenOrderModal } from "components/OrderModal/state/orderModalSlice";
export default function StikckyFooter({
  showBottomSticky,
  installingBtnBlockActive,
  count,
}) {
  const { productInfo, currentLanguage, currentCurrency, favorites, compares } =
    useSelector(({ main }) => main);
  const product = productInfo?.product;

  const productImgRef = useRef();

  const dispatch = useDispatch();

  const handleImageError = (event) => {
    event.target.onerror = null; // Prevent infinite loop
    event.target.src = defaultImg; // Set default image on error
  };

  if (!Object.keys(product || {}).length) return null;
  return (
    <section
      className={`${styles.container} ${showBottomSticky && styles.show}`}>
      <div className={styles.wrapper}>
        <div
          className={styles.productImg}
          ref={productImgRef}>
          <img
            src={
              (() => {
                const img = product?.gallary_images_api?.[0];
                const path = img?.images_source || img?.thum_image_sourc || img?.image || img?.url;
                return path ? getImageUrl(path) : defaultImg;
              })()
            }
            onError={handleImageError}
            alt="Product Img"
          />
        </div>
        <div className={styles.nameBlock}>
          <span className={styles.name}>
            {product?.brand.name + " " + product?.product_name}
          </span>
        </div>
        {product?.sticker?.[0]?.["image_" + currentLanguage] ? (
          <img
            className={styles.stickerImg}
            src={getImageUrl(product.sticker[0]["image_" + currentLanguage]) || defaultImg}
            alt="Sticker"
          />
        ) : (product?.online_price && product?.online_selling_price) ? (
          <span className={styles.onlineSticker}>
            {langData?.treeInOne?.blackTitle?.[currentLanguage] ?? "ONLY FOR ONLINE"}
          </span>
        ) : null}

        <div className={styles.nameBlock}>
          <div className={styles.price_block}>
            <span className={styles.priceText}>
              {" "}
              {lang[currentLanguage].price}
            </span>
            <span className={styles.priceNumber}>
              {product?.skus?.[0].promo_price ||
              (product?.online_price && product?.online_selling_price) ? (
                <>
                  <span className={styles.newPrice}>
                    {UseCalcPrice(
                      product?.skus?.[0].promo_price ||
                        (product?.online_price &&
                          product?.online_selling_price),
                      currentCurrency
                    )}
                  </span>
                  <div className={styles.oldPriceBlock}>
                    <span className={styles.oldPrice}>
                      {UseCalcPrice(
                        product?.skus?.[0].selling_price,
                        currentCurrency
                      )}
                    </span>
                    <span className={styles.oldPriceLine} />
                  </div>
                </>
              ) : (
                <span className={styles.price}>
                  {UseCalcPrice(
                    product?.skus?.[0].selling_price,
                    currentCurrency
                  )}
                </span>
              )}
            </span>
          </div>
        </div>

        <div className={styles.compareHeart}>
          <div
            onClick={() => {
              if (!compares.includes(product?.skus?.[0]?.id)) {
                if (product?.gallary_images_api?.[0]?.images_source) {
                  const { top, left } =
                    productImgRef.current?.getBoundingClientRect();

                  dispatch(
                    setCompareProductAnimation({
                      image: product?.gallary_images_api?.[0]?.images_source,
                      position: {
                        top,
                        left,
                      },
                    })
                  );
                }

                dispatch(addCompares(product?.skus?.[0]?.id));
              } else {
                dispatch(removeCompares(product?.skus?.[0]?.id));
              }
              dispatch(
                addCompare({
                  product_sku_id: product.skus?.[0]?.id,
                })
              );
            }}>
            <CompareSvg active={compares.includes(product?.skus?.[0]?.id)} />
          </div>
          <span />
          <div
            onClick={() => {
              const sellerProductId = productInfo?.id ?? product?.id;
              if (!favorites.includes(sellerProductId)) {
                if (product?.gallary_images_api?.[0]?.images_source) {
                  const { top, left } =
                    productImgRef.current?.getBoundingClientRect();

                  dispatch(
                    setHeartProductAnimation({
                      image: product?.gallary_images_api?.[0]?.images_source,
                      position: {
                        top,
                        left,
                      },
                    })
                  );
                }
                dispatch(addFavorites(sellerProductId));
              } else {
                dispatch(removeFavorites(sellerProductId));
              }
              dispatch(
                addWishList({
                  seller_product_id: sellerProductId,
                })
              );
            }}>
            <HeartSvg active={favorites.includes(productInfo?.id ?? product?.id)} />
          </div>
        </div>
        {product?.li_product_id ? (
          <div
            className={`${styles.buyBtn} ${styles.addCartBtn}`}
            onClick={() => {
              if (product?.gallary_images_api?.[0].images_source) {
                const { top, left } =
                  productImgRef.current?.getBoundingClientRect();

                dispatch(
                  setShopCartProductAnimation({
                    image: product?.gallary_images_api?.[0]?.images_source,
                    position: {
                      top,
                      left,
                    },
                  })
                );
              }
              dispatch(
                addShopCartCount({
                  price:
                    +(
                      (product?.skus?.[0].promo_price ||
                        product?.skus[0]?.selling_price) -
                      ((!installingBtnBlockActive &&
                        product.installing_price) ||
                        0)
                    ) * count,
                  count: count,
                })
              );
              dispatch(
                addCardStore({
                  price:
                    +product?.promo_price ||
                    +(product?.online_price && product?.online_selling_price) ||
                    +product?.skus[0]?.selling_price,
                  qty: 1,
                  product_id: product?.skus?.[0]?.id,
                  seller_id: 1,
                  shipping_method_id: 0,
                  type: "product",
                  is_buy_now: "no",
                })
              );
            }}>
            <ShopCartSvg className={styles.cardBtnSvg} />
            <span>{lang[currentLanguage].add}</span>
          </div>
        ) : (
          <button
            className={`${styles.buyBtn} ${styles.orderBtn}`}
            onClick={() => {
              dispatch(setOpenOrderModal({ open: true, id: product.id }));
            }}>
            {lang?.[currentLanguage].order}
          </button>
        )}
      </div>
    </section>
  );
}